import { render, staticRenderFns } from "./CourseWorkloadText.vue?vue&type=template&id=c55c8fc2&scoped=true"
import script from "./CourseWorkloadText.vue?vue&type=script&lang=js"
export * from "./CourseWorkloadText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c55c8fc2",
  null
  
)

export default component.exports